export default "__VITE_ASSET__BRkDytH3__"